<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <div class="brand">
      <img :src="require('@/assets/images/sxy.png')" alt="乐闪派">
      <div class="title">快消品经销商首选专业管理软件</div>
    </div>
    <el-main style="margin-top: 30px;">
      <el-form :label-position="labelPosition" :model="ruleForm" status-icon :rules="rules" ref="ruleForm"
        label-width="42px" class="demo-ruleForm login_form" size="medium">
        <el-form-item label="" class="ref_type_btns">
          <el-col :span="12">
            <el-link :type="ref_type == 0 ? 'primary' : ''" @click="changeRegType">手机验证</el-link>
          </el-col>
          <el-col :span="12">
            <el-link :type="ref_type == 1 ? 'primary' : ''" @click="changeRegType">邮箱验证</el-link>
          </el-col>
        </el-form-item>
        <el-form-item label="" prop="phone" v-if="ref_type == 0">
          <el-input type="text" v-model="ruleForm.phone" autocomplete="off" placeholder="手机号"
            prefix-icon="el-icon el-icon-mobile-phone"></el-input>
        </el-form-item>
        <el-form-item label="" prop="mailbox" v-else :rules="{
          required: true, message: '请输入邮箱', trigger: 'blur'
        }">
          <el-input type="text" v-model="ruleForm.mailbox" autocomplete="off" placeholder="邮 箱"
            prefix-icon="el-icon el-icon-message"></el-input>
        </el-form-item>
        <el-form-item label="" prop="Password">
          <el-input type="password" v-model="ruleForm.Password" autocomplete="off" placeholder="密码至少包含大小写字母各一位，长度不少于8位"
            prefix-icon="el-icon el-icon-unlock"></el-input>
        </el-form-item>
        <el-form-item label="" prop="Password2">
          <el-input placeholder="确认密码" v-model="ruleForm.Password2" show-password autocomplete='off'
            prefix-icon="el-icon el-icon-unlock"></el-input>
        </el-form-item>
        <el-form-item label="" prop="VerifyCode">
          <el-input type="text" v-model="ruleForm.VerifyCode" placeholder="验证码" prefix-icon="el-icon el-icon-chat-round">
            <template slot="append">
              <el-link @click="getCode" :disabled="timeNumber != 0">{{ timeNumber == 0 ? codeTip : timeNumber + 's可重发' }}
              </el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">重置密码</el-button>
        </el-form-item>
        <el-form-item>
          <el-col :span="12">
            <router-link :to="{ path: '/login' }" style="text-decoration: none;float:left">
              <el-link type="primary">跳转到登录页</el-link>
            </router-link>
          </el-col>
          <el-col :span="12">
            <router-link :to="{ path: '/' }" style="text-decoration: none;float:right">
              <el-link type="primary">回到首页</el-link>
            </router-link>
          </el-col>
        </el-form-item>
      </el-form>
    </el-main>
    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  verifyCodeSend,
  forgetPwdReset
} from '@/api.js'
import {
  mapState
} from 'vuex'
export default {
  name: "Login",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value && (!(/^[1][3456789]\d{9}$/).test(value) || !(/^[1-9]\d*$/).test(value) || value.length !== 11)) {
        callback(new Error('请输入正确的手机号'))
      } else if (value == '') {
        callback(new Error('请输入手机号'))
      } else {
        callback()
      }
    };
    var checkCode = (rule, value, callback) => {
      // const num = this.identifyCode.identifyCode.replace('=', '').split('+');
      if (value === '') {
        callback(new Error('请输入验证码'));
      }
      // else if ((num[0] * 1 + num[1] * 1) != value) {
      //   callback(new Error('验证码输入错误'));
      // } 
      else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'));
      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/.test(value)) {
        callback(new Error('密码至少包含大小写字母各一位，长度不少于8位'));
      } else {
        callback();
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.Password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    }
    return {
      ref_type: 0,
      timeNumber: 0,
      codeTimer: null,
      codeTip: '获取短信验证码',
      labelPosition: 'left',
      ruleForm: {
        mailbox: '',
        phone: '',
        Passport: '',
        PassportType: '',
        Password: '',
        Password2: '',
        VerifyCode: '',
        CheckCode: ''
      },
      rules: {
        phone: [{
          validator: checkPhone,
          trigger: 'blur'
        }],
        Password: [{
          validator: validatePass,
          trigger: 'blur'
        }],
        Password2: [{
          validator: validatePass2,
          trigger: 'blur'
        }],
        VerifyCode: [{
          validator: checkCode,
          trigger: 'blur'
        }]
      },
    };
  },
  mounted() {

  },
  methods: {
    changeRegType() {
      this.$refs['ruleForm'].resetFields();
      this.ref_type = !this.ref_type
      if (this.ref_type == 0) {
        clearInterval(this.codeTimer)
        this.timeNumber = 0
        this.codeTip = '获取短信验证码'
      } else {
        clearInterval(this.codeTimer)
        this.timeNumber = 0
        this.codeTip = '获取邮箱验证码'
      }
    },
    getCode() {
      const field = this.ref_type == 0 ? 'phone' : 'mailbox'
      this.$refs['ruleForm'].validateField(field, (vaild) => {
        console.log(vaild)
        if (vaild == '') {
          verifyCodeSend({
            SendType: this.ref_type == 0 ? 1 : 2,
            Passport: this.ref_type == 0 ? this.ruleForm.phone : this.ruleForm.mailbox,
            VerifyType: 2
          }).then(res => {
            if (res.code == 0) {
              this.ruleForm.CheckCode = res.data.checkCode
              this.timeNumber = 60
              this.codeTimer = setInterval(() => {
                this.timeNumber--
                if (this.timeNumber == 0) {
                  clearInterval(this.codeTimer)
                }
              }, 1000);
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.Passport = this.ref_type == 0 ? this.ruleForm.phone : this.ruleForm.mailbox
          this.ruleForm.PassportType = this.ref_type == 0 ? 1 : 3
          forgetPwdReset(this.ruleForm).then(res => {
            if (res.code == 0) {
              this.$router.push({
                path: '/'
              })
            } else {
              this.$message.error(res.message);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  computed: {
    ...mapState({
      identifyCode: state => state.identifyCode
    }),
  },
}
</script>
<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}
.el-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .el-link.el-link--primary {
    color: #409EFF;
  }
}

.brand {
  position: absolute;
  left: calc(50% - 112px);
  top: 60px;

  img {
    width: 220px;
  }

  .title {
    color: #606266;
  }
}

.login_form {
  padding-top: 20px;
  width: 400px;
  /* height: 324px; */
  border-radius: 10px;

  .title {
    text-align: center;
    font-size: 24px;
    width: 84%;
    margin: 0 auto;
    line-height: 60px;
    margin-bottom: 20px;
    position: relative;
  }

  .ref_type_btns {
    .el-link {
      font-size: 16px;
      font-weight: 600;
    }
  }

  .el-input-group__append {
    width: 100px;
  }
}

.login_form .el-form-item__content {
  margin-left: 40px !important;
  position: relative;
}

.login_form .el-icon {
  position: absolute;
  top: 11px;
  left: 5px;
  z-index: 2;
}

.login_form .el-input input {
  padding-left: 25px;
}

.login_form .el-form-item {
  padding-right: 42px;
  position: relative;
}

.login_form .el-button--primary {
  width: 100%;
  font-size: 20px;
  font-weight: 700;
}

.v_code {
  width: calc(100% - 115px);
}
</style>